import { type RecommendationExtensionsOptions } from './types';
import { createProductExtensions } from './utils';

export type { ProvisioningPageExtensionsOptions } from './types';

export const recommendationContextExtensionsWhitelist = ['recommendationContext'];

export const createRecommendationContextExtensions = (options: RecommendationExtensionsOptions) =>
	createProductExtensions<{
		recommendationContext: RecommendationExtensionsOptions;
	}>(recommendationContextExtensionsWhitelist)({
		recommendationContext: options,
	});
